<template>
  <div class="readdraw-module">
    <div class="read-edit" v-if="viewStatus != 2">
      阅读组件编辑区域(预览/发布后该区域不显示)
    </div>
    <div class="read-btn" :style="aStyle" @click="onShowTips"></div>
    <ReadTip
      ref="readDrawPrize"
      :img="draw.prizes || defaultPrizes"
      :isFinished="isFinished"
      :prizeNum="prizeNum"
      v-if="state.isShowDialogReadTip"
      @start-turns="startTurns"
    />
    <ReadEffect
      :img="draw.prizeAni || defaultAni"
      v-if="state.isShowDialogReadEffect"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import infos from '@/utils/infos';
import ReadTip from './ReadTip.vue';
import ReadEffect from './ReadEffect.vue';
export default {
  name: 'McRead',
  props: {
    draw: {
      type: Object,
      default: () => {}
    },
    view: {
      type: Object,
      default: () => {}
    },
    drawNumber: {
      type: Number,
      default: () => null
    },
    list: {
      type: Array,
      default: () => []
    },
    moduleId: {
      type: Number
    },
    viewStatus: {
      type: Number
    }
  },
  data() {
    return {
      defaultFloat:
        '//cdn-tx-admin-test.3kwan.com/2023/07/20/8a05138d185c108d36f389ab1f26f853.gif',
      defaultPrizes:
        '//cdn-tx-admin-test.3kwan.com/2023/07/20/d9446f74597608bebb83ce4f70c1fc6b.png',
      defaultAni:
        '//cdn-tx-admin-test.3kwan.com/2023/07/20/0ec2021663e87d33d4ed0c51c6429370.gif',
      prizeNum: 0,
      lock: false,
      time: null
    };
  },
  components: {
    ReadTip,
    ReadEffect
  },
  computed: {
    state() {
      return this.$store.state;
    },
    ...mapGetters(['prize']),
    aStyle() {
      return {
        backgroundImage: `url(${this.draw.floatBtn || this.defaultFloat})`
      };
    },
    isFinished() {
      return (
        this.state.userInfo.read_progress >=
          (this.view?.ext_params?.read_progress || 0) &&
        this.state.userInfo.read_time >= (this.view?.ext_params?.read_time || 0)
      );
    }
  },
  watch: {
    'view.ext_params.draw_number': {
      deep: true,
      immediate: true,
      handler() {
        this.prizeNum = this.view.ext_params.draw_number;
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
    this.prizeNum = this.view.ext_params.draw_number;
  },
  methods: {
    onShowTips() {
      if (this.viewStatus != 2) return;
      this.$store.commit('OPEN_DIALOG', 'ReadTip');
    },
    onScroll() {
      clearTimeout(this.time);
      let process =
        (100 * infos.scrollTop) / (infos.scrollHeight - window.innerHeight);
      console.log('process', process);
      this.time = setTimeout(() => {
        this.$store.commit('UPDATE_USERINFO', {
          read_progress: Math.floor(
            Math.max(
              isNaN(process) ? 0 : process,
              this.state.userInfo.read_progress
            )
          ),
          read_time: Math.floor(
            (new Date().getTime() - this.state.userInfo.local_begin_time) / 1000
          )
        });
      }, 200);
    },
    // 延迟函数
    async delay(time = 2000) {
      return new Promise((res) => {
        setTimeout(() => {
          res();
        }, time);
      });
    },
    async runAni() {
      this.$store.commit('CLOSE_DIALOG', 'ReadTip');
      await this.delay(700);
      this.$store.commit('OPEN_DIALOG', 'ReadEffect');
      await this.delay(3000);
      this.$store.commit('CLOSE_DIALOG', 'ReadEffect');
      this.endTurns();
    },
    startTurns() {
      // this.runAni();
      if (this.viewStatus != 2) return;
      if (this.state.userInfo.guid === '') {
        this.$store.commit('OPEN_DIALOG', 'Guid');
        return false;
      }
      if (!this.canBeRotated()) {
        return false;
      }
      this.lock = true;
      this.drawPrize();
    },
    //请求服务端抽奖
    async drawPrize() {
      let { code, data } = await this.$api.prize.drawPrize({
        module_id: this.moduleId,
        guid: this.state.userInfo.guid,
        server_id: this.state.userInfo.server_id,
        role_id: this.state.userInfo.role_id,
        ext_params: {
          read_progress: this.state.userInfo.read_progress,
          read_time: this.state.userInfo.read_time
        }
      });
      if (code !== 0) {
        this.lock = false;
        return;
      }
      this.Track(4, this.moduleId);
      this.$store.commit('UPDATE_PRIZE', data);
      this.runAni();
      // 成功后次数减少一次
      this.prizeNum--;
    },
    endTurns() {
      // 中奖
      this.$store.commit('OPEN_DIALOG', 'Prize');
      // 解锁
      this.lock = false;
    },
    canBeRotated() {
      if (this.lock) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.read-edit {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.read-btn {
  position: fixed;
  top: 50%;
  right: 10px;
  width: 140px;
  height: 140px;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 500;
  transform: translateY(-50%);
}
</style>
